<template>
    <div>
        <legend>Прайс партнера</legend>
        <dx-data-grid
                :show-borders="true"
                :data-source="dataSource"
                :remote-operations="true"
                :column-min-width="100"
        >
            <dx-editing
                    :allow-updating="true"
                    :allow-deleting="true"
                    :allow-adding="true"
                    mode="row"
            />

            <dx-column
                    data-field="Name"
                    caption="Название"
            />
            <dx-column
                    data-field="Sku"
                    caption="Артикул"
            />
            <dx-column
                    v-for="priceList in priceLists"
                    :data-field="priceList.Name"
                    :caption="priceList.Name"
            />
        </dx-data-grid>

    </div>
</template>
<script>
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { DxColumn, DxDataGrid, DxEditing } from 'devextreme-vue/data-grid';
import { get } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/price`;


export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  data() {
    return {
      priceLists: [],
    };
  },
  async mounted() {
    await this.fetchPriceList();
  },
  watch: {
    '$route.params.partnerGroupId': function () {
      this.fetchPriceList();
    },
  },
  computed: {
    dataSource() {
      const token = this.$auth.token();
      return createStore({
        key: 'Id',
        loadUrl: `${url}/${this.$route.params.partnerGroupId}/${this.$route.params.paymentTypeId}`,
        insertUrl: `${url}/${this.$route.params.partnerGroupId}/insert`,
        updateUrl: `${url}/update`,
        deleteUrl: `${url}/delete`,
        onBeforeSend(operation, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`,
          };
        },
      });
    },
  },
  methods: {
    async fetchPriceList() {
      const { data } = await get(`${url}/columns/${this.$route.params.partnerGroupId}`);
      this.priceLists = data;
      console.log(data);
    },
  },
};
</script>
